import "./App.css";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import { useEffect, useState } from "react";
import Cookies from "js-cookie";

// Import pages and components
import Login from "./Components/pages/Login";
import OtpInput from "./Components/pages/otpInput";
import Questions from "./Components/pages/Questions";
import Final from "./Components/pages/Final";
import ProtectedRoute from "./Components/ProtectedRoute";
import First from "./Components/pages/First";
import NotFound from "./Components/pages/NotFound"; // Import the NotFound component
import ErrorPage from "./Components/pages/ErrorPage";
import Success from "./Components/pages/Success";
import Help from "./Components/QuestionsList/Help";


function App() {

    // const [language, setLanguage] = useState("en");

    //  // Read the language cookie when the component mounts.
    // useEffect(() => {
    //   const cookieLang = Cookies.get("selectedLanguage") || "en";
    //   setLanguage(cookieLang);
    // }, []);

    // // Handler to update language state and cookie when user changes language
    // const handleLanguageChange = (event) => {
    //   const newLanguage = event.target.value;
    //   setLanguage(newLanguage);
    //   Cookies.set("selectedLanguage", newLanguage, { expires: 365 });
    // };

    
  return (
    <Router>
      <div className="App" >
        {/* <div className="translate">
        <select value={language} onChange={handleLanguageChange}>
          <option value="en">English</option>
          <option value="Hi">हिंदी</option>
          <option value="Kn">ಕನ್ನಡ</option>
        </select>
        </div> */}
      
        <Routes>
          
          <Route path="/" element={ <First />} />
          <Route path="/help" element={ <Help />} />
          <Route path="/login"  element={<Login />} />
          <Route path="/otp" element={ <OtpInput /> } />

          {/* Protected Routes */}
          <Route
            path="/questions"
            element={
              <ProtectedRoute>
                <Questions />
              </ProtectedRoute>
            }
          />
          <Route
            path="/success"
            element={
              // <ProtectedRoute>
                <Final />
              // </ProtectedRoute>
            }
          />
                    <Route
            path="/submited"
            element={
              // <ProtectedRoute>
                <Success />
              // </ProtectedRoute>
            }
          />
            <Route path="*" element={<ErrorPage />} />    
                  <Route path="*" element={<NotFound />} />                                  
        </Routes>
      </div>
    </Router>
  );
}

export default App;
